export default {
  "HitPaw Online Audio Joiner": "合并音频",
  "Merge Audio": "音频合并",
  "Merge multiple audio tracks into one.": "将多音频轨道合并成一个",
  "Merge New": "合并新的文件",
  "Merge failed": "合并失败",
  "Fade in": "淡入",
  "Fade out": "淡出",
  "Add tracks": "添加轨道",
  "Format": "格式",
};
